import { Spinner } from '@pb/shared/ui/atoms/spinner';
import { Layout } from '@pb/apps/offers/ui/layout';
import { StyledSpinnerContainer } from './loading-spinner.styled';

export function LoadingSpinner() {
    return (
        <Layout>
            <StyledSpinnerContainer>
                <Spinner />
            </StyledSpinnerContainer>
        </Layout>
    );
}
